export class Ruta {
    id: string;
    codRuta?: number; // ID de la ruta en el servidor
    nombre: string;
    puntoOrigen: {
        gid: number;
        nombre: string;
        latitud: number;
        longitud: number;
    };
    puntoDestino: {
        gid: number;
        nombre: string;
        latitud: number;
        longitud: number;
    };
    puntosIntermedios: {
        gid?: number;
        nombre: string;
        latitud: number;
        longitud: number;
    }[]; // Waypoints o puntos intermedios
    opciones: RutaOpcion[];
    rutaSeleccionada: number; // índice de la opción seleccionada
    visible: boolean;
    color: string;
    fechaCreacion: Date;
    tiempoMaximoMinutos?: number; // Tiempo máximo para alerta (de minuto_alerta del servidor)
    polyline?: any; // Polyline de Google Maps
    distanciaMetros?: number; // Distancia en metros
    duracionSegundos?: number; // Duración en segundos

    constructor(data: any) {
        this.id = data['id'] || this.generateId();
        this.codRuta = data['codRuta'] || null;
        this.nombre = data['nombre'] || '';
        this.puntoOrigen = data['puntoOrigen'] || null;
        this.puntoDestino = data['puntoDestino'] || null;
        this.puntosIntermedios = data['puntosIntermedios'] || [];
        this.opciones = data['opciones'] || [];
        this.rutaSeleccionada = data['rutaSeleccionada'] || 0;
        this.visible = data['visible'] !== undefined ? data['visible'] : true;
        this.color = data['color'] || this.generateRandomColor();
        this.fechaCreacion = data['fechaCreacion'] ? new Date(data['fechaCreacion']) : new Date();
        this.tiempoMaximoMinutos = data['tiempoMaximoMinutos'] || 30;
        this.polyline = data['polyline'] || null;
        this.distanciaMetros = data['distanciaMetros'] || 0;
        this.duracionSegundos = data['duracionSegundos'] || 0;
    }

    private generateId(): string {
        return 'ruta_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    }

    private generateRandomColor(): string {
        const colors = ['#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8', '#F7DC6F', '#BB8FCE', '#85C1E2'];
        return colors[Math.floor(Math.random() * colors.length)];
    }
}

export class RutaOpcion {
    indice: number;
    distancia: number; // en metros
    duracion: number; // en segundos
    polyline: string; // encoded polyline de Google Maps
    puntos: { lat: number; lng: number }[];
    resumen: string;

    constructor(data: any) {
        this.indice = data['indice'] || 0;
        this.distancia = data['distancia'] || 0;
        this.duracion = data['duracion'] || 0;
        this.polyline = data['polyline'] || '';
        this.puntos = data['puntos'] || [];
        this.resumen = data['resumen'] || '';
    }

    getDistanciaKm(): string {
        return (this.distancia / 1000).toFixed(2) + ' km';
    }

    getDuracionMinutos(): string {
        const minutos = Math.floor(this.duracion / 60);
        if (minutos < 60) {
            return minutos + ' min';
        }
        const horas = Math.floor(minutos / 60);
        const mins = minutos % 60;
        return horas + 'h ' + mins + 'min';
    }
}
